import {Button, Modal} from "semantic-ui-react";

export const ConfirmationModal = ({ open, setOpen, submitAction }) => {
    return (
        <Modal
            open={open}
            onClose={() => setOpen(false)}
            size="tiny"
        >
            <Modal.Header>Are you sure you want to delete this weather station?</Modal.Header>
            <Modal.Actions>
                <Button onClick={() => setOpen(false)}>
                    Cancel
                </Button>
                <Button className={'ui primary button'} onClick={submitAction}>
                    Delete
                </Button>
            </Modal.Actions>
        </Modal>
    )
}